<script>
import Layout from "./base";
import Swal from "sweetalert2";

export default {
    components: { Layout, Swal },
    props:{
        submiturl: {
        type: String,
        required: true
        },
        autherror: {
        type: String,
        required: false,
        default: () => null
        },
        autenticado:'',
        regiones:{},
        comunas:{},
        cartData: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            title: "Starter Page",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            desc:0,
            envio:null,
            datos_envio:{
                nombre:'',
                rut:'',
                direccion:'',
                direccion2:'',
                region:'',
                comuna:'',
                telefono:'',
                email:'',
                otra_nombre:'',
                otra_nombre:'',
                otra_rut:'',
                otra_direccion:'',
                otra_direccion2:'',
                otra_dir:'',
                otra_region:'',
                otra_comuna:'',
                notas:''
            },
            boton_webpay:false,
            screen:{},
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            promociones:[],
            promo:[],
            cantidad:0,
            porcentaje:0,
        };
    },
    computed:{
        cartItems(){
            return this.$store.getters.cartItems;
        },
        cartTotal() {
            return this.$store.getters.cartTotal;
        },
        total(){
            let total=0;
            total= this.cartTotal + this.envio - this.desc
            return total
        },
        comunasFiltradas() {
            if (!this.datos_envio.region) return [];
                return this.comunas.filter(comuna => comuna.region_id == this.datos_envio.region);
        },
        comunasFiltradas_otras() {
            if (!this.datos_envio.otra_region) return [];
                return this.comunas.filter(comuna => comuna.region_id == this.datos_envio.otra_region);
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods:{
        removeFromCart(index) {
            this.$store.dispatch('removeFromCart', index);
            this.revisar_promocion();
        },
        increaseQuantity(index) {
            this.$store.dispatch('increaseQuantity', index);
            this.revisar_promocion();
        },
        decreaseQuantity(index) {
            this.$store.dispatch('decreaseQuantity', index);
            this.revisar_promocion();
        },
        ver_modal_direccion(){
            this.$refs['modal_direccion'].show()
        },
        pagar_webpay(){
            this.revisar_promocion();
            if (this.validarCampos()) {
                this.regiones.forEach(reg => {
                    if (reg.id == this.datos_envio.region) {
                        this.envio = reg.valor;
                    }
                });
                this.boton_webpay=true
                let payload={
                    cartItems:this.$store.getters.cartItems,
                    cartTotal:this.$store.getters.cartTotal,
                    envio:this.envio,
                    desc:this.desc,
                    tipo:'Webpay',
                    rut:this.datos_envio.rut,
                    telefono:this.datos_envio.telefono,
                    email:this.datos_envio.email,
                    datos_envio:this.datos_envio,
                }
                console.log(payload)
                axios.post('/api/nueva_orden',payload).then(res=>{
                    if (res.data.estado) {
                        window.location.href = `/orden/${res.data.orden.uid}`;
                    }else{
                        console.log(res.data.mensaje);
                        this.boton_webpay=false
                    }
                }).catch(error => {
                    if (error.response.status == 422) {
                        const errors = error.response.data.errors;
                        Object.keys(errors).forEach(key => {
                            errors[key].forEach(message => {
                                // Aquí puedes mostrar cada mensaje de error en tu interfaz de usuario
                                console.error(message);
                            });
                        });
                        this.boton_webpay=false
                    } else {
                        console.error(error);
                    }
                })
            } else {
                let camposFaltantes = this.obtenerCamposFaltantes();
                let mensaje = 'Por favor, completa los siguientes campos obligatorios:\n';
                camposFaltantes.forEach(campo => {
                    mensaje += '- ' + campo + '\n';
                });
                confirm(mensaje);
                console.log('Formulario inválido');
            }
        },
        obtenerCamposFaltantes() {
            let camposFaltantes = [];
            let objeto = Object.keys(this.datos_envio)
            Object.keys(this.datos_envio).forEach(campo => {
                if (this.datos_envio[campo].toString().trim() == '' && campo !== 'otra_dir' && campo != 'direccion2' && campo != 'otra_nombre' && campo != 'otra_rut' && campo !== 'otra_direccion' && campo != 'otra_direccion2' && campo != 'otra_dir' && campo != 'otra_region' && campo != 'otra_comuna') {
                    camposFaltantes.push(campo.charAt(0).toUpperCase() + campo.slice(1));
                }
            });
            if(this.datos_envio.otra_dir){
                objeto.forEach(campo => {
                    if (this.datos_envio[campo].toString().trim() == '' && campo != 'otra_dir' && campo != 'otra_direccion2' && campo != 'nombre' && campo != 'rut' && campo != 'direccion' && campo != 'direccion2' && campo != 'region' && campo != 'comuna') {
                        camposFaltantes.push(campo.charAt(0).toUpperCase() + campo.slice(1));
                    }
                });
            }
            return camposFaltantes;
        },
        validarCampos() {
            return (
                this.datos_envio.nombre.trim() !== '' &&
                this.datos_envio.rut.trim() !== '' &&
                this.datos_envio.direccion.trim() !== '' &&
                this.datos_envio.region !== '' &&
                this.datos_envio.comuna !== '' &&
                this.datos_envio.telefono.trim() !== '' &&
                this.datos_envio.email.trim() !== ''
                // Agrega más validaciones aquí para otros campos si es necesario
            );
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            console.log(this.windowWidth);
            console.log(this.windowHeight);
        },
        sub(item){
            let valor = item.precio*item.cantidad;
            return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        sub_normal(item){
            let valor_normal = item.precio_normal*item.cantidad;
            return valor_normal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        encontrarProductoMenorPrecio(marca) {
            const resultado = this.productos.reduce((acumulador, productoActual, indiceActual) => {
                if (productoActual.marca == marca) {
                if (acumulador == null || productoActual.precio < acumulador.producto.precio) {
                    return { producto: productoActual, indice: indiceActual };
                }
                }
                return acumulador;
            }, null);
            
            return resultado ? resultado : { producto: null, indice: null };
        },
        revisar_promocion(check=false){
            axios.get('/api/get_promociones').then(res=>{
                this.promociones=res.data.promociones||[];
                this.promo=this.promociones.filter(p=>p.estado==1);

                const toInt=v=>parseInt((v||0).toString().replace(/[^\d\-]/g,''))||0;
                const hasPromo = i => {
                    if (!i.promocion) return false;
                    // Convertir a string y verificar si es promoción del sistema
                    const promoStr = String(i.promocion);
                    return promoStr.includes('cxll:') || promoStr.includes('acum:');
                }

                let carro;try{
                    carro=JSON.parse(localStorage.getItem("cart_sin_promo"))||JSON.parse(localStorage.getItem("cart"))||[];
                }catch{carro=[]}
                console.log('Carro antes de promociones:', carro);
                // snapshot base sin promo
                localStorage.setItem("cart_sin_promo",JSON.stringify(carro));
                
                // ===== PROMO 1: comprexllevey (ámbito=marca) =====
                const promoCXLL=this.promo.find(p=>p.tipo==='comprexllevey'&&p.ambito==='marca');
                if(promoCXLL){
                    const marca=String(promoCXLL.detalle_ambito||'');
                    const N=toInt(promoCXLL.cantidad);
                    if(N>0){
                        // candidatos válidos sin promo, con precio_normal>0 y cantidad>0
                        let candidatos=carro.filter(i=>i.marca===marca&&!hasPromo(i)&&toInt(i.precio_normal)>0&&toInt(i.cantidad)>0);
                        const total=candidatos.reduce((t,i)=>t+toInt(i.cantidad),0);
                        let gratis=Math.floor(total/N);

                        console.log('items gratis:', gratis);
                        if (gratis > 0) {
                            // Construir una lista expandida de unidades candidata: [{producto_id, precio_normal, origenIndex}]
                            let unidades = [];
                            candidatos.forEach(c => {
                                const cantidad = toInt(c.cantidad);
                                for (let u = 0; u < cantidad; u++) {
                                    unidades.push({ producto_id: c.producto_id, precio_normal: toInt(c.precio_normal || c.precio || 0), referencia: c });
                                }
                            });

                            // Ordenar unidades por precio ascendente (cheapest first)
                            unidades.sort((a, b) => a.precio_normal - b.precio_normal);

                            // Tomar las primeras 'gratis' unidades como gratuitas
                            const gratuitas = unidades.slice(0, gratis);

                            if (gratuitas.length > 0) {
                                // Reducir cantidades en el carrito original según las gratuitas tomadas
                                const gratisPorProducto = {};
                                gratuitas.forEach(g => {
                                    gratisPorProducto[g.producto_id] = (gratisPorProducto[g.producto_id] || 0) + 1;
                                });

                                // Aplicar la reducción en 'carro' y agregar ítems gratuitos con precio 0
                                Object.keys(gratisPorProducto).forEach(pid => {
                                    let toRemove = gratisPorProducto[pid];
                                    // Buscar entries en carro que correspondan a pid y no tengan promo
                                    for (let idx = 0; idx < carro.length && toRemove > 0; idx++) {
                                        const p = carro[idx];
                                        if (p.producto_id == pid && !hasPromo(p) && toInt(p.cantidad) > 0) {
                                            const tomar = Math.min(toInt(p.cantidad), toRemove);
                                            // disminuir cantidad
                                            carro[idx] = { ...carro[idx], cantidad: toInt(carro[idx].cantidad) - tomar };
                                            // agregar item gratuito (usar última referencia de candidatos para datos)
                                            const ref = candidatos.find(c => c.producto_id == pid) || p;
                                            carro.push({ ...ref, cantidad: tomar, precio: 0, precio_normal: 0, precio_rebajado: 0, promocion: `cxll:${pid}` });
                                            toRemove -= tomar;
                                            if (toInt(carro[idx].cantidad) <= 0) {
                                                // dejar para luego filtrar
                                            }
                                        }
                                    }
                                });

                                // Eliminar entradas con cantidad 0
                                carro = carro.filter(i => toInt(i.cantidad) > 0 || (i.promocion && String(i.promocion).startsWith('cxll:')));
                            }
                        }
                    }
                }

                // ===== PROMO 2: acumulado (ámbito=categoría) =====
                const promoAc=this.promo.find(p=>p.tipo==='acumulado'&&p.ambito==='categoria');
                if(promoAc){
                    const categoria=String(promoAc.detalle_ambito||'');
                    const escalas={1:10,2:15,3:20,4:25};
                    const esDeCategoria=p=>{
                        if(!p.categorias) return false;
                        const arr=p.categorias.toString().split(',').map(s=>s.trim());
                        return arr.includes(categoria);
                    };
                    const productosCat=carro.filter(p=>!hasPromo(p)&&esDeCategoria(p)&&toInt(p.cantidad)>0);
                    const cantidadTotal=productosCat.reduce((s,p)=>s+toInt(p.cantidad),0);
                    let porcentaje=0;Object.keys(escalas).map(k=>toInt(k)).sort((a,b)=>a-b).forEach(k=>{if(cantidadTotal>=k) porcentaje=escalas[k]});
                    if(porcentaje>0){
                        for(const p of productosCat){
                            const nuevo=Math.round((toInt(p.precio_normal)||toInt(p.precio)||0)*(1-porcentaje/100));
                            p.precio_rebajado=nuevo;p.precio=nuevo;p.promocion=`acum:${porcentaje}%`;
                        }
                        this.porcentaje=porcentaje;
                    }
                }

                localStorage.setItem("cart",JSON.stringify(carro));
                this.$store.dispatch('initializeStore');
                if(check) window.location.href='/checkout';
            });
        },

        irACheckout() {
            this.revisar_promocion(true);
        }

    },
    created() {
        this.regiones = JSON.parse(this.regiones);
        this.comunas = JSON.parse(this.comunas);
        
        // Handle external cart data
        console.log(this.autenticado==''?'No logueado':'Logueado')
        console.log('CartData prop received:', this.cartData);
        if (this.cartData && this.cartData.trim() !== '') {
            console.log('Received external cart data:', this.cartData);
            try {
                const externalCart = JSON.parse(this.cartData);
                if (Array.isArray(externalCart) && externalCart.length > 0) {
                    // Clear existing cart
                    localStorage.removeItem('cart');
                    localStorage.removeItem('cart_sin_promo');
                    
                    // Set new cart data
                    localStorage.setItem('cart', JSON.stringify(externalCart));
                    
                    // Initialize store with external data
                    this.$store.dispatch('initializeStore');
                    
                    console.log('External cart data loaded:', externalCart);
                }
            } catch (error) {
                console.error('Error parsing external cart data:', error);
            }
        }
        
        // if(this.direccion!==''){
        //     this.direccion=JSON.parse(this.direccion)
        //     this.datos_envio.direccion=this.direccion.direccion
        //     this.datos_envio.direccion2=this.direccion.direccion2
        //     this.datos_envio.region=this.direccion.region
        //     this.datos_envio.comuna=this.direccion.comuna
        // }
        console.log(this.regiones[0].id)
        this.screen=window.screen
        this.handleResize()
        this.revisar_promocion();
        //console.log(this.screen);
    },
};
</script>
<template>
    <Layout :submiturl='submiturl' :autherror="autherror" :autenticado="autenticado">
        <div class="row">
            <div class="col-xl-8">
                <div class="card">
                    <div class="card-body">
                        <div class="table-responsive" v-if="windowWidth>576">
                            <table class="table table-centered mb-0 table-nowrap">
                                <thead class="thead-light">
                                    <tr>
                                        <th>Producto</th>
                                        <th>Producto Desc.</th>
                                        <!-- <th>Precio</th> -->
                                        <th>Cantidad</th>
                                        <th colspan="2">SubTotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in cartItems" :key="index">
                                        <td>
                                            <img :src="item.imagen" alt="product-img" title="product-img" class="avatar-md" />
                                        </td>
                                        <td>
                                            <h5 class="font-size-14 text-truncate">
                                                <a :href="'/producto/'+item.producto_id" class="text-dark">{{item.nombre}}</a>
                                            </h5>
                                            <p class="mb-0" v-if="item.tipo=='Variable'">
                                                <span class="font-weight-medium">{{item.titulo}}</span>
                                            </p>
                                        </td>
                                        <!-- <td>$ {{item.precio}}</td> -->
                                        <td>
                                            <div style="display: flex;">
                                                <b-button variant="primary" size="sm" @click="decreaseQuantity(index)" :disabled="item.precio=='0'?true:false">-</b-button>
                                                <p class="m-0 mx-3 mt-2">{{item.cantidad}}</p>
                                                <b-button variant="primary" size="sm" @click="increaseQuantity(index)" :disabled="item.precio=='0'?true:false">+</b-button>
                                            </div>
                                        </td>
                                        <td>
                                            <span v-if="sub(item) !== sub_normal(item)">
                                                <s style="color:red">$ {{ sub_normal(item) }}</s> 
                                            </span>
                                            $ {{ sub(item) }}
                                        </td>
                                        <td class="text-center">
                                            <b-button size="sm" variant="danger" @click="removeFromCart(index)" v-if="item.precio!='0'"><i class="mdi mdi-trash-can font-size-14"></i></b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else>
                            <div class="mt-4" v-for="(item,index) in cartItems" :key="index">
                                <h4>Producto {{ index+1 }}</h4>
                                <table class="table mb-0" >
                                    <tbody>
                                        <tr>
                                            <td>Producto</td>
                                            <td>
                                                <img :src="item.imagen" alt="product-img" title="product-img" class="avatar-md" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Producto Desc.</td>
                                            <td>
                                                <h5 class="font-size-14 text-truncate">
                                                    <a :href="'/producto/'+item.producto_id" class="text-dark">{{item.nombre}}</a>
                                                </h5>
                                                <p class="mb-0" v-if="item.tipo=='Variable'">
                                                    <span class="font-weight-medium">{{item.titulo}}</span>
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Cantidad</td>
                                            <td>
                                                <div style="display: flex;">
                                                    <b-button variant="primary" size="sm" @click="decreaseQuantity(index)" :disabled="item.precio=='0'?true:false">-</b-button>
                                                    <p class="m-0 mx-3">{{item.cantidad}}</p>
                                                    <b-button variant="primary" size="sm" @click="increaseQuantity(index)" :disabled="item.precio=='0'?true:false">+</b-button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>SubTotal</td>
                                            <td>$ {{sub(item) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Eliminar del carro</td>
                                            <td class="text-center">
                                                <b-button size="sm" variant="danger" @click="removeFromCart(index)" :disabled="item.precio=='0'?true:false"><i class="mdi mdi-trash-can font-size-14"></i></b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-3">Resumen de Compra</h4>
                        <div class="dropdown-divider">
                        </div>
                        <!-- <p v-if="this.porcentaje>0"><strong></strong>{{ this.porcentaje }}% de descuento en categoria aplicado.</strong></p>/ -->
                        <div class="table-responsive">
                            <table class="table mb-0">
                                <tbody>
                                    <tr>
                                        <td>Total :</td>
                                        <td>$ {{ cartTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") }}</td>
                                    </tr>
                                    <tr v-if="desc!=0">
                                        <td>Descuento :</td>
                                        <td>- $ 157</td>
                                    </tr>
                                    <tr >
                                        <td>Envio :</td>
                                        <td v-if="envio==null">Sin datos de envio</td>
                                        <td v-else>${{envio}}</td>
                                    </tr>
                                    <tr>
                                        <th>Total :</th>
                                        <th>$ {{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <b-button class="mb-3" variant="primary" pill block @click="irACheckout">Comprar</b-button>
                                <a href="/filtrar" >
                                    Seguir Comprando
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>